class Colonnes {
    root: NodeListOf<HTMLElement>;
    columns: NodeListOf<HTMLElement>;
    constructor() {
        this.root = document.querySelectorAll('.wp-block-columns');
        this.columns = document.querySelectorAll('.is-layout-flow');
    }

    classForWidth() {
        this.columns.forEach((col: HTMLElement) => {
            const width = col.offsetWidth;

            let divWidth: Array<string> = [];

            if(width >= 1450) {
                divWidth.push('xl');
            }
            if (width < 1450) {
                divWidth.push('lg');
            }
            if (width < 1130) {
                divWidth.push('md');
            }
            if (width < 765) {
                divWidth.push('sm');
            }
            if (width < 500) {
                divWidth.push('xs');
            }

            divWidth.forEach(s => {
                col.classList.add(s);
                col.setAttribute('data-width', s);
            })
        })
    }

    init() {
        if(this.root) {
            this.classForWidth();
        }
    }
}

window.addEventListener('DOMContentLoaded', () => {
    const colonnes = new Colonnes();

    colonnes.init();
})